import { Link } from "react-router-dom";
import { ARTICLES, readingTime, formatDate } from "./articles";

export const ArticleCard = ({ a, index = 0 }) => (
  <article data-testid={`journal-card-${a.slug}`} className="group">
    <Link to={`/journal/${a.slug}`} className="block" aria-label={a.title}>
      <div className="aspect-[16/10] overflow-hidden bg-erth-black/5">
        <img
          src={a.cover}
          alt={a.coverAlt}
          loading={index < 2 ? "eager" : "lazy"}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
        />
      </div>
      <p className="mt-5 font-body text-xs tracking-[0.22em] text-erth-black/50">
        {a.property ? "dune villas" : "erth. escapes"} · {readingTime(a)} min read · {formatDate(a.date)}
      </p>
      <h3 className="mt-3 font-head text-xl font-semibold leading-snug text-erth-black transition-opacity group-hover:opacity-70 sm:text-2xl">
        {a.title}
      </h3>
      <p className="mt-3 font-body text-base font-light leading-relaxed text-erth-black/70">{a.description}</p>
    </Link>
  </article>
);

export const relatedTo = (a, n = 2) => ARTICLES.filter((x) => x.slug !== a.slug).slice(0, n);
